export const ASSISTANT_URL = "https://asistentelegalcl.botvirtualia.com"
// export const ASSISTANT_URL = "http://localhost:9000"
// nada

export const ASSISTANT_AUTH_LOGIN_URL = `${ASSISTANT_URL}/api/auth/login`;
export const ASSISTANT_AUTH_REGISTER_URL = `${ASSISTANT_URL}/api/auth/register`;

export const ASSISTANT_AUTH_GOOGLE_URL = `${ASSISTANT_URL}/api/auth/google`;
export const ASSISTANT_AUTH_MICROSOFT_URL = `${ASSISTANT_URL}/api/auth/microsoft`;

export const ASSISTANT_CHAT_HISTORY_URL = `${ASSISTANT_URL}/api/chat/history/s3`;
export const ASSISTANT_CHAT_SEND_URL = `${ASSISTANT_URL}/api/chat/send`;
export const ASSISTANT_REPORT_DOWNLOAD_URL = `${ASSISTANT_URL}/api/chat/report`;
export const ASSISTANT_AUTH_RECOVER_URL = `${ASSISTANT_URL}/api/auth/recover`;
export const ASSISTANT_AUTH_RESET_PASSWORD_URL = `${ASSISTANT_URL}/api/auth/reset-password`;
export const ADMIN_SESSION_URL = `${ASSISTANT_URL}/api/administracion/sesion`;
export const ADMIN_ASSISTANT_URL = `${ASSISTANT_URL}/api/administracion/asistente`;
export const ADMIN_USERS_URL = `${ASSISTANT_URL}/api/administracion/usuarios`;
export const ADMIN_EXPEDIENTE_URL = `${ASSISTANT_URL}/api/administracion/expediente`;
export const EXPEDIENTES_URL = `${ASSISTANT_URL}/api/expedientes`;


